import DAboutFirstBlockRussianBox from './DAboutFirstBlockRussianBox'

export default DAboutFirstBlockRussianBox
